import { lazy } from 'react'
const routes = [
  // {
  //   path: '/',
  //   name: 'dashboard',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/Home/Home')),
  //   meta: {
  //     title: 'dashboard',
  //     icon: 'DashboardOutlined',
  //     permission: 'DASHBOARD',
  //   },
  //   children: [],
  // },
  // {
  //   path: '/orders',
  //   name: 'orders',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/Orders')),
  //   meta: {
  //     title: 'orders',
  //     icon: 'ShoppingCartOutlined',
  //     permission: 'ORDER',
  //   },
  //   children: [
  //     {
  //       path: '/orders/table/add',
  //       name: 'add',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Orders/Table/Add')),
  //       meta: { title: 'add', icon: '', permission: 'CREATE_ORDER' },
  //       children: [],
  //     },
  //     {
  //       path: '/orders/table/edit',
  //       name: 'edit',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Orders/Table/Edit')),
  //       meta: { title: 'edit', icon: '', permission: 'UPDATE_ORDER' },
  //       children: [],
  //     },
  //   ],
  // },
  {
    path: '/mikrozaym',
    name: 'mikrozaym',
    isSub: false,
    component: lazy(() => import('@/pages/Microzaym')),
    meta: {
      title: 'microzaym',
      icon: 'ScheduleOutlined',
      permission: 'COLLECTION',
    },
    children: [
      {
        path: '/mikrozaym/form-create',
        name: 'form-create',
        isSub: false,
        component: lazy(() => import('@/pages/Microzaym/Create')),
        meta: { title: 'create', icon: '', permission: 'COLLECTION' },
        children: [],
      },
      {
        path: '/mikrozaym/form-create/:id',
        name: 'form-edit',
        isSub: false,
        component: lazy(() => import('@/pages/Microzaym/Create')),
        meta: { title: 'edit', icon: '', permission: 'COLLECTION' },
        children: [],
      },
      {
        path: '/mikrozaym/table/add',
        name: 'add',
        isSub: false,
        component: lazy(() => import('@/pages/Microzaym/Table/Add')),
        meta: { title: 'add', icon: '', permission: 'COLLECTION' },
        children: [],
      },
      // {
      //   path: '/microzaym/table/edit',
      //   name: 'edit',
      //   isSub: false,
      //   component: lazy(() => import('@/pages/Microzaym/Table/Edit')),
      //   meta: { title: 'edit', icon: '', permission: 'COLLECTION' },
      //   children: [],
      // },
      {
        path: '/microzaym/table/:id',
        name: 'edit',
        isSub: false,
        component: lazy(() => import('@/pages/Microzaym/Table/Info')),
        meta: { title: 'edit', icon: '', permission: 'COLLECTION' },
        children: [],
      },

      // ]
    ],
  },
  {
    path: '/tracking',
    name: 'tracking',
    isSub: false,
    component: lazy(() => import('@/pages/Tracking')),
    meta: {
      title: 'tracking',
      icon: 'ScheduleOutlined',
      permission: 'COLLECTION',
    },
    children: [
      {
        path: '/tracking/:id',
        name: 'tracking-detail',
        isSub: false,
        component: lazy(() => import('@/pages/Tracking/Detail')),
        meta: {
          title: 'tracking_detail',
          icon: '',
          permission: 'COLLECTION',
        },
        children: [],
      },
    ],
  },
  {
    path: '/couriers',
    name: 'mobileRepresentatives',
    isSub: false,
    component: lazy(() => import('@/pages/MobileRepresentatives/MobileRepresentatives')),
    meta: {
      title: 'mob.representatives',
      icon: 'MobileOutlined',
      permission: 'COURIER',
    },
    children: [
      {
        path: '/couriers/create',
        name: 'create',
        isSub: false,
        component: lazy(() => import('@/pages/MobileRepresentatives/CreateCourier')),
        meta: {
          title: 'create',
          icon: '',
          permission: 'CREATE_COURIER',
        },
        children: [],
      },
      {
        path: '/couriers/edit',
        name: 'edit',
        isSub: false,
        component: lazy(() => import('@/pages/MobileRepresentatives/EditCourier')),
        meta: { title: 'edit', icon: '', permission: 'UPDATE_COURIER' },
        children: [],
      },
    ],
  },
  // {
  //   path: '/reports',
  //   name: 'reports',
  //   isSub: true,
  //   // component: lazy(() => import('@/pages/Reports/Orders')),
  //   meta: { title: 'reports', icon: 'ProjectOutlined', permission: 'REPORT' },
  //   children: [
  //     {
  //       path: '/reports/by-representatives',
  //       name: 'by.representatives',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Representatives/Representatives')),
  //       meta: {
  //         title: 'by.representatives',
  //         icon: 'UsergroupAddOutlined',
  //         permission: 'GET_REPORT_COURIER',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-branches',
  //       name: 'by.branches',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Branches/Branches')),
  //       meta: {
  //         title: 'by.branches',
  //         icon: 'ShopOutlined',
  //         permission: 'GET_REPORT_BRANCH',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-products',
  //       name: 'by.products',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Products/Products')),
  //       meta: {
  //         title: 'by.products',
  //         icon: 'ShoppingOutlined',
  //         permission: 'GET_REPORT_PRODUCT',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-bugs',
  //       name: 'ReportsBugs',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Bugs/Bugs')),
  //       meta: {
  //         title: 'by.bugs',
  //         icon: 'BugOutlined',
  //         permission: 'GET_BUG_REPORT',
  //         children: [],
  //       },
  //     },
  //     {
  //       path: '/reports/by-call',
  //       name: 'by.calls',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/CallAndNFC/CallTable')),
  //       meta: {
  //         title: 'by.call',
  //         icon: 'PhoneOutlined',
  //         permission: 'GET_REPORT_BY_CALL',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-nfc',
  //       name: 'by.nfc',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/CallAndNFC/index')),
  //       meta: {
  //         title: 'by.nfc',
  //         icon: 'ApartmentOutlined',
  //         permission: 'GET_REPORT_COURIER_CHECK',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-courier-status',
  //       name: 'by.courier.status',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/CourierStatuses')),
  //       meta: {
  //         title: 'by.representative.status',
  //         icon: 'UserSwitchOutlined',
  //         permission: 'GET_REPORT_COURIER_STATUS',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-canceled',
  //       name: 'by.canceled',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Canceled/Canceled')),
  //       meta: {
  //         title: 'by.canceled',
  //         icon: 'CloseCircleOutlined',
  //         permission: 'GET_REPORT_CANCELLED',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/by-canceled-reason',
  //       name: 'by.canceled.reason',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/CancelledReason')),
  //       meta: {
  //         title: 'by.canceled.reason',
  //         icon: 'QuestionCircleOutlined',
  //         permission: 'GET_REPORT_CANCEL_REASON',
  //       },
  //       children: [],
  //     },
  //     {
  //       path: '/reports/total',
  //       name: 'ReportsTotal',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Total/Total')),
  //       meta: {
  //         title: 'overall',
  //         icon: 'ProfileOutlined',
  //         permission: 'GET_TOTAL_REPORT',
  //         children: [],
  //       },
  //     },
  //     {
  //       path: '/reports/by-daily-volume',
  //       name: 'ReportsDailyVolume',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/DailyVolume/DailyVolume')),
  //       meta: {
  //         title: 'by.daily.volume',
  //         icon: 'CalendarOutlined',
  //         permission: 'GET_REPORT_DAILY_VOLUME',
  //         children: [],
  //       },
  //     },
  //     {
  //       path: '/reports/by-distribution',
  //       name: 'ReportsDistribution',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Reports/Distribution/Distribution')),
  //       meta: {
  //         title: 'by.distribution',
  //         icon: 'FieldTimeOutlined',
  //         permission: 'GET_REPORT_DAILY_ASSIGN',
  //         children: [],
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/directory',
  //   name: 'directory',
  //   isSub: true,
  //   // component: lazy(() => import('@/pages/Directory/Directory')),
  //   meta: {
  //     title: 'directory',
  //     icon: 'InfoCircleOutlined',
  //     permission: 'DIRECTORY',
  //   },
  //   children: [
  //     {
  //       path: '/catalog',
  //       name: 'catalog',
  //       isSub: true,
  //       // component: lazy(() => import('@/pages/Catalog/Catalog')),
  //       meta: {
  //         title: 'catalog',
  //         icon: 'ControlOutlined ',
  //         permission: 'CATALOGY',
  //       },
  //       children: [
  //         {
  //           path: '/catalog/category',
  //           name: 'category',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Catalog/Category/Category')),
  //           meta: {
  //             title: 'category',
  //             icon: 'ReadOutlined',
  //             permission: 'CATEGORY',
  //           },
  //           children: [
  //             {
  //               path: '/catalog/category/create',
  //               name: 'CategoryCreate',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Catalog/Category/Create')),
  //               meta: {
  //                 title: 'category_create',
  //                 icon: '',
  //                 permission: 'CREATE_CATEGORY',
  //               },
  //               children: [],
  //             },
  //             {
  //               path: '/catalog/category/edit',
  //               name: 'CategoryEdit',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Catalog/Category/Create')),
  //               meta: {
  //                 title: 'category_create',
  //                 icon: '',
  //                 permission: 'UPDATE_CATEGORY',
  //               },
  //               children: [],
  //             },
  //           ],
  //         },
  //         {
  //           path: '/catalog/product',
  //           name: 'product',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Catalog/Product/Product')),
  //           meta: {
  //             title: 'product',
  //             icon: 'ShoppingOutlined',
  //             permission: 'PRODUCT',
  //           },
  //           children: [
  //             {
  //               path: '/catalog/product/create',
  //               name: 'ProductCreate',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Catalog/Product/Create')),
  //               meta: {
  //                 title: 'product_create',
  //                 icon: '',
  //                 permission: 'CREATE_PRODUCT',
  //               },
  //               children: [],
  //             },
  //             {
  //               path: '/catalog/product/edit',
  //               name: 'ProductEdit',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Catalog/Product/Create')),
  //               meta: {
  //                 title: 'product_edit',
  //                 icon: '',
  //                 permission: 'UPDATE_PRODUCT',
  //               },
  //               children: [],
  //             },
  //           ],
  //         },
  //         {
  //           path: '/catalog/documents',
  //           name: 'documents',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Documents/Documents')),
  //           meta: {
  //             title: 'documents',
  //             icon: 'FileTextOutlined',
  //             permission: 'DOCUMENT',
  //           },
  //           children: [
  //             {
  //               path: '/catalog/documents/create',
  //               name: 'create',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Documents/CreateDocuments')),
  //               meta: {
  //                 title: 'create.documents',
  //                 icon: '',
  //                 permission: 'CREATE_DOCUMENT',
  //               },
  //               children: [],
  //             },
  //             {
  //               path: '/catalog/documents/edit',
  //               name: 'edit',
  //               isSub: false,
  //               component: lazy(() => import('@/pages/Documents/EditDocument')),
  //               meta: {
  //                 title: 'edit.documents',
  //                 icon: '',
  //                 permission: 'UPDATE_DOCUMENT',
  //               },
  //               children: [],
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       path: '/geofence',
  //       name: 'geofence',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Geofence/Geofence')),
  //       meta: {
  //         title: 'geofence',
  //         icon: 'EnvironmentOutlined',
  //         permission: 'GEOZONE',
  //       },
  //       children: [
  //         {
  //           path: '/geofence/create',
  //           name: 'create',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Geofence/Map/CreateMap')),
  //           meta: { title: 'create', icon: '', permission: 'CREATE_GEOZONE' },
  //           children: [],
  //         },
  //         {
  //           path: '/geofence/edit',
  //           name: 'edit',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Geofence/Map/EditMap')),
  //           meta: { title: 'edit', icon: '', permission: 'UPDATE_GEOZONE' },
  //           children: [],
  //         },
  //       ],
  //     },
  //     {
  //       path: '/branches',
  //       name: 'branches',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Branches/Branches')),
  //       meta: {
  //         title: 'branches',
  //         icon: 'ShopOutlined',
  //         permission: 'BRANCH',
  //       },
  //       children: [
  //         {
  //           path: '/branches/create',
  //           name: 'create',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Branches/CreateBranch')),
  //           meta: { title: 'create.branch', icon: '', permission: 'CREATE_BRANCH' },
  //           children: [],
  //         },
  //         {
  //           path: '/branches/edit',
  //           name: 'edit',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Branches/EditBranch')),
  //           meta: { title: 'edit.branch', icon: '', permission: 'UPDATE_BRANCH' },
  //           children: [],
  //         },
  //       ],
  //     },
  //     {
  //       path: '/fuels',
  //       name: 'fuels',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/Fuel/Fuels.js')),
  //       meta: {
  //         title: 'fuels',
  //         icon: 'ShopOutlined',
  //         permission: 'FUEL',
  //       },
  //       children: [
  //         {
  //           path: '/fuels/create',
  //           name: 'create',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Fuel/Create.js')),
  //           meta: { title: 'create.branch', icon: '', permission: 'CREATE_FUEL' },
  //           children: [],
  //         },
  //         {
  //           path: '/fuels/edit',
  //           name: 'edit',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/Fuel/Edit.js')),
  //           meta: { title: 'edit.branch', icon: '', permission: 'UPDATE_FUEL' },
  //           children: [],
  //         },
  //       ],
  //     },
  //     {
  //       path: '/contact-type',
  //       name: 'contact_type',
  //       isSub: false,
  //       component: lazy(() => import('@/pages/ContactType/index.js')),
  //       meta: {
  //         title: 'contact_type',
  //         icon: 'ShopOutlined',
  //         permission: 'CONTACT_TYPE',
  //       },
  //       children: [
  //         {
  //           path: '/contact-type/create',
  //           name: 'create',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/ContactType/Create.js')),
  //           meta: { title: 'create.contact_type', icon: '', permission: 'CREATE_CONTACT_TYPE' },
  //           children: [],
  //         },
  //         {
  //           path: '/contact-type/edit',
  //           name: 'edit',
  //           isSub: false,
  //           component: lazy(() => import('@/pages/ContactType/Edit.js')),
  //           meta: { title: 'edit.contact_type', icon: '', permission: 'UPDATE_CONTACT_TYPE' },
  //           children: [],
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    path: '/notification',
    name: 'Notification',
    isSub: false,
    component: lazy(() => import('@/pages/Notification')),
    meta: {
      title: 'notification',
      icon: 'BellOutlined',
      permission: 'NOTIFICATION',
      // type: 'SUPER-ADMIN',
    },
    children: [
      {
        path: '/notification/create',
        name: 'create',
        isSub: false,
        component: lazy(() => import('@/pages/Notification/Create')),
        meta: {
          title: 'create',
          icon: '',
          permission: 'CREATE_NOTIFICATION',
          // type: 'SUPER-ADMIN',
        },
        children: [],
      },
    ],
  },
  {
    path: '/branch-user',
    name: 'branchUser',
    isSub: false,
    component: lazy(() => import('@/pages/BranchUser/List')),
    meta: {
      title: 'branch.user',
      icon: 'UserSwitchOutlined',
      permission: 'BRANCH_USER',
      // type: 'SUPER-ADMIN',
    },
    children: [
      {
        path: '/branch-user/create',
        name: 'create',
        isSub: false,
        component: lazy(() => import('@/pages/BranchUser/Create')),
        meta: {
          title: 'create',
          icon: '',
          permission: 'CREATE_BRANCH_USER',
        },
        children: [],
      },
      {
        path: '/branch-user/edit/:id',
        name: 'edit',
        isSub: false,
        component: lazy(() => import('@/pages/BranchUser/Create')),
        meta: {
          title: 'edit',
          icon: '',
          permission: 'UPDATE_BRANCH_USER',
        },
        children: [],
      },
    ],
  },
  {
    path: '/supervisor',
    name: 'supervisor',
    isSub: false,
    component: lazy(() => import('@/pages/Supervisor/List')),
    meta: {
      title: 'supervisor',
      icon: 'UserOutlined',
      permission: 'SUPERVISOR',
    },
    children: [
      {
        path: '/supervisor/create',
        name: 'create',
        isSub: false,
        component: lazy(() => import('@/pages/Supervisor/Create')),
        meta: {
          title: 'create',
          icon: '',
          permission: 'CREATE_SUPERVISOR',
        },
        children: [],
      },
      {
        path: '/supervisor/edit/:id',
        name: 'edit',
        isSub: false,
        component: lazy(() => import('@/pages/Supervisor/Create')),
        meta: {
          title: 'edit',
          icon: '',
          permission: 'UPDATE_SUPERVISOR',
        },
        children: [],
      },
      {
        path: '/supervisor/employees/:id',
        name: 'employees',
        isSub: false,
        component: lazy(() => import('@/pages/Supervisor/Employees')),
        meta: {
          title: 'employees',
          icon: '',
          permission: 'GET_LIST_SUPERVISOR',
        },
        children: [],
      },
    ],
  },

  // {
  //   path: '/couriers-salary',
  //   name: 'Couriers Salary',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/CourierSalary/CourierSalary')),
  //   meta: {
  //     title: 'couriers_salary',
  //     icon: 'TeamOutlined',
  //     permission: 'COURIER_SALARY',
  //     // type: 'SUPER-ADMIN',
  //   },
  //   children: [],
  // },
  {
    path: '/role',
    name: 'Couriers Salary',
    isSub: false,
    component: lazy(() => import('@/pages/Role/Role')),
    meta: {
      title: 'Роли',
      icon: 'UnlockOutlined',
      permission: 'ROLE',
      type: 'SUPER-ADMIN'
    },
    children: [
      {
        path: '/role/edit/:id',
        name: 'edit',
        isSub: false,
        component: lazy(() => import('@/pages/Role/Edit')),
        meta: {
          title: 'edit',
          icon: '',
          permission: 'UPDATE_ROLE',
        },
        children: [],
      },
    ],
  },
  // {
  //   path: '/configs',
  //   name: 'Configs',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/Configs/Configs')),
  //   meta: {
  //     title: 'configs',
  //     icon: 'SettingOutlined',
  //     permission: 'CONFIG',
  //     type: 'SUPER-ADMIN',
  //   },
  //   children: [],
  // },
  // {
  //   path: '/actions',
  //   name: 'actions',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/Actions')),
  //   meta: {
  //     title: 'actions',
  //     icon: 'SettingOutlined',
  //     permission: 'CONFIG',
  //     type: 'SUPER-ADMIN',
  //   },
  //   children: [],
  // },
  // {
  //   path: '/captcha-log-list',
  //   name: 'loglist',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/CaptchaLogList')),
  //   meta: {
  //     title: 'captcha.logs',
  //     icon: 'SettingOutlined',
  //     // permission: 'CAPTCHA_LOG_LIST',
  //     permission: 'CONFIG',
  //     type: 'SUPER-ADMIN',
  //   },
  //   children: [],
  // },
  // {
  //   path: '/permissions',
  //   name: 'Permissions',
  //   isSub: false,
  //   component: lazy(() => import('@/pages/Permissions/Permissions')),
  //   meta: {
  //   title: 'permissions',
  //     icon: 'LockOutlined',
  //     permission: 'permission',
  //     type: 'SUPER-ADMIN',
  //   },
  //   children: [],
  // },




  {
    path: '/404',
    name: '404',
    component: lazy(() => import('@/pages/statuses/404')),
    hidden: true,
    meta: { title: '404', permission: '404' },
    children: [],
  },
]

export default routes
